import React from 'react';
import { View, StyleSheet } from 'react-native';
import { MyEventModel } from '../../types';
import { themeConfig } from '../../styles/themeConfig';
import QRCode from '../QRCode';
import { BText } from '../BText';

type props = {
  event: MyEventModel;
};

export const Ticket = ({ event }: props) => {
  return (
    <View style={styles.container}>
      <BText style={styles.ticketName}>{event.attendanceName}</BText>
      <View style={styles.qrView}>
        <QRCode value={event.ticketNumber} size={120} />
      </View>
      <View style={styles.ticketInfo}>
        <BText style={styles.ticketText}>Ticket ID {event.ticketNumber}</BText>
        <BText style={styles.ticketDesc}>* Show QR code to staff to check in.</BText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 10,
    marginBottom: 40,
    height: 279,
    width: '100%',
    borderRadius: themeConfig.settings.borderRadius,
    backgroundColor: themeConfig.colors.white,
    padding: 16,
  },
  ticketName: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 18,
    marginBottom: 24,
  },
  qrView: {
    alignItems: 'center',
    marginBottom: 16,
  },
  ticketInfo: {
    flexDirection: 'column',
    marginVertical: 16,
  },
  ticketText: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  ticketDesc: {
    fontSize: 12,
    textAlign: 'center',
  },
});
